import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatFancyTime'
})
export class FormatFancyTimePipe implements PipeTransform {

  transform(duration: number): string {
    let durationPreventNaN = this.preventNaN(duration);
    const durationFormatted =  (durationPreventNaN - (durationPreventNaN %= 60)) / 60 + (9 < durationPreventNaN ? ':' : ':0') + durationPreventNaN;
    return durationFormatted+ ' ' + (duration > 59 ? 'min' : 'sec');
  }


  public preventNaN(number: number) {
    return isNaN(number) || number === Infinity ? 0 : number;
  }

}
